import script from "./VersionDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./VersionDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./VersionDisplay.vue?vue&type=style&index=0&id=0d4c6c8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4c6c8f"]])

export default __exports__